import React from 'react';

import {getAvailability} from 'dev-platform/swagger-ui/util';
import SwaggerUiPage from 'dev-platform/SwaggerUiPage';
import WebhookReferencePage from 'dev-platform/WebhookReferencePage';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactElement} from 'util/RootReactRender';

export const DevPlatformRoutes: RouteBundle = {
  domain: 'dev-platform',
  routes: [
    {urlPattern: 'api', handler: swaggerUiPageLanding, legacy: true},
    {urlPattern: 'api/reference', handler: swaggerUiPageLanding, legacy: true},
    {urlPattern: 'api/:version/reference', handler: swaggerUiPage, legacy: true},
    {urlPattern: 'webhooks/reference', handler: webhooksUiPageLanding, legacy: true},
  ],
};

function swaggerUiPageLanding(): void {
  DatadogUtil.startRUMView('api_reference');
  renderReactElement(<SwaggerUiPage version={null} availabilityToShow={getAvailability()} />);
}

function swaggerUiPage(version: string): void {
  DatadogUtil.startRUMView('api_version_reference');
  renderReactElement(<SwaggerUiPage version={version} availabilityToShow={getAvailability()} />);
}

function webhooksUiPageLanding(): void {
  DatadogUtil.startRUMView('webhooks_reference');
  renderReactElement(<WebhookReferencePage />);
}
